import Swiper from 'swiper';

// CONSTANTS
import {
  ROUTE_BLOG_POST,
  ROUTE_BLOG_AUTHOR,
  ROUTE_BLOG_CATEGORY,
  ROUTE_NEWS_POST,
  ROUTE_NEWS_CATEGORY,
  ROUTE_NEWS_AUTHOR,
  ROUTE_PARTNER_BLOG_POST,
  ROUTE_PARTNER_BLOG_AUTHOR,
  ROUTE_PARTNER_BLOG_CATEGORY,
  ROUTE_PARTNER_NEWS_POST,
  ROUTE_PARTNER_NEWS_CATEGORY,
  ROUTE_PARTNER_NEWS_AUTHOR,
} from '@/constants/routes';
import {
  WP_GET_POSTS,
  WP_GET_NEWS,
  WP_GET_NEWS_CATEGORIES,
  WP_GET_CATEGORIES,
} from '@/constants/api-wp';

export const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
export const wpDomain = process.env.REACT_APP_WP_DOMAIN;
export const wpComposerPublicPath = `${wpDomain}/wp-content/plugins/visualcomposer/public`;
export const wpComposerAssetsPath = `${wpDomain}/wp-content/uploads/visualcomposer-assets`;

export const mainComposerScripts = [
  `${wpComposerPublicPath}/dist/front.bundle.js`,
  `${wpComposerPublicPath}/dist/runtime.bundle.js`,
];

export class WPData {
  scriptsCount = 0;

  scriptsLoaded = [];

  carousels = [];

  reset = () => {
    this.scriptsCount = 0;
    this.scriptsLoaded = [];

    this.resetCarousels();
  };

  resetCarousels = () => {
    if (this.carousels.length) {
      this.carousels.forEach(carousel => {
        try {
          carousel.destroy(true, false);
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);
        }
      });

      this.carousels = [];
    }
  };
}

function initSwiper(wpData) {
  try {
    const containers = document.querySelectorAll('.swiper-carousel');

    containers.forEach(container => {
      if (!container.swiper) {
        const instance = new Swiper(container, {
          pagination: {
            el: '.swiper-pagination',
          },
          slidesPerView: 4,
          slidesPerGroup: 4,
          breakpoints: {
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
            600: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            1000: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          },
        });

        wpData.carousels.push(instance);
      }
    });
  } catch (error) {
    // eslint-disable-next-line
    console.error(error);
  }
}

export function runComposer(wpData) {
  if (window.vcv) {
    setTimeout(() => {
      window.vcv.trigger('ready');
    }, 200);
  }

  if (wpData) {
    initSwiper(wpData);
  }
}

export function connectScripts(array, wpData) {
  wpData.scriptsCount += array.length;

  array.forEach(jsSrc => {
    const script = document.createElement('script');
    let src = jsSrc;
    const hasHTTP = src.includes('http');

    if (wpDomain) {
      if (!hasHTTP) {
        if (src.includes('elements') || src.includes('sharedLibraries')) {
          src = `${wpComposerAssetsPath}/${jsSrc}`;
        } else {
          src = `${wpComposerPublicPath}/sources/${jsSrc}`;
        }
      }

      script.src = src;

      document.body.appendChild(script);

      script.onload = () => {
        wpData.scriptsLoaded.push(true);

        if (wpData.scriptsCount === wpData.scriptsLoaded.length) {
          runComposer(wpData);
        }
      };
    }
  });
}

export function removeScripts(array, wpData) {
  const targetelement = 'script';
  const allsuspects = document.getElementsByTagName(targetelement);

  for (const src of array) {
    for (const script of allsuspects) {
      if (script.src && script.src.indexOf(src) !== -1) {
        script.parentNode.removeChild(script);
      }
    }
  }

  wpData.reset();
}

export function removeCss(filename) {
  const targetelement = 'link';
  const allsuspects = document.getElementsByTagName(targetelement);

  for (const css of allsuspects) {
    if (css.href && css.href.indexOf(filename) !== -1) {
      css.parentNode.removeChild(css);
    }
  }
}

export function manageClickListeners(items, action = 'add', fnc) {
  items.forEach(item => {
    if (action === 'add') {
      item.addEventListener('click', fnc);
    } else {
      item.removeEventListener('click', fnc);
    }
  });
}

export function getLinksByType(type) {
  let post;
  let category;
  let author;
  let partnerPost;
  let partnerCategory;
  let partnerAuthor;

  switch (type) {
    case 'news':
      post = ROUTE_NEWS_POST;
      category = ROUTE_NEWS_CATEGORY;
      author = ROUTE_NEWS_AUTHOR;
      partnerPost = ROUTE_PARTNER_NEWS_POST;
      partnerCategory = ROUTE_PARTNER_NEWS_CATEGORY;
      partnerAuthor = ROUTE_PARTNER_NEWS_AUTHOR;
      break;
    default:
      post = ROUTE_BLOG_POST;
      category = ROUTE_BLOG_CATEGORY;
      author = ROUTE_BLOG_AUTHOR;
      partnerPost = ROUTE_PARTNER_BLOG_POST;
      partnerCategory = ROUTE_PARTNER_BLOG_CATEGORY;
      partnerAuthor = ROUTE_PARTNER_BLOG_AUTHOR;
      break;
  }

  return {
    post,
    category,
    author,
    partnerPost,
    partnerCategory,
    partnerAuthor,
  };
}

export function getAPIUrlsByType(type) {
  let post;
  let category;

  switch (type) {
    case 'news':
      post = WP_GET_NEWS;
      category = WP_GET_NEWS_CATEGORIES;
      break;
    default:
      post = WP_GET_POSTS;
      category = WP_GET_CATEGORIES;
      break;
  }

  return {
    post,
    category,
  };
}
